// 성과 측정 카드
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import CreatorInfo from "./CreatorInfo";

function AccordionContent({ item, isExpanded, progress, total, ongoing, creatorCount }) {
  const [renderChildren, setRenderChildren] = useState(false);
  const isCps = String(item?.campaign?.billingModel ?? "").toUpperCase() === "CPS";
  const firstCreatorUnitPrice = Number(item?.creators?.[0]?.target?.unitPrice ?? 0);
  const cpsRate = firstCreatorUnitPrice * 100;
  const totalManuscriptFee = item?.summary?.totals?.totalManuscriptFee;
  const totalExpectedCommission = item?.summary?.totals?.totalExpectedCommission;
  const totalClicks = item?.summary?.totals?.totalClicks;
  const totalQuantity = item?.summary?.totals?.totalQuantity;
  const totalRoas = item?.summary?.totals?.roas;
  const formatCurrency = (value) => {
    const n = Number(value ?? 0);
    if (Number.isNaN(n)) return "-";
    return `₩${Math.round(n).toLocaleString()}`;
  };

  useEffect(() => {
    if (isExpanded) {
      const t = setTimeout(() => setRenderChildren(true), 180);
      return () => clearTimeout(t);
    } else {
      setRenderChildren(false);
    }
  }, [isExpanded]);

  return (
    <>
      <AccordionButton
                py="14px"
                px="18px"
                _hover={{ bg: "gray.50" }}
                _expanded={{ bg: "#F5F9FF" }}
                justifyContent="space-between"
                transition="background 0.2s"
              >
                <Flex
                  align="center"
                  flexDir="row"
                  gap="16px"
                  justify="space-between"
                  w="100%"
                >
                  <Flex flexDir="column" align="flex-start" gap="2px" flex="1" minW="0">
                    <Text
                      fontSize="20px"
                      fontWeight="700"
                      color="#172940"
                      noOfLines={1}
                    >
                      {item?.campaign?.title}
                    </Text>
                    {!isExpanded && (creatorCount > 0 || total > 0) && (
                      <Text fontSize="14px" color="#5D6979" fontWeight={500}>
                        {total > 0
                          ? `참여 크리에이터 ${creatorCount}명 · 진행 ${ongoing}/${total}`
                          : `크리에이터 ${creatorCount}명`}
                      </Text>
                    )}
                  </Flex>
                  {(!isExpanded || isCps) && (
                    <Flex
                      align="center"
                      gap="10px"
                      flexShrink={0}
                      flexWrap={isCps ? "wrap" : "nowrap"}
                      justifyContent={isCps ? "flex-end" : "flex-start"}
                      maxW={isCps ? "65%" : "none"}
                    >
                      {!isCps && (
                        <>
                          <Flex
                            align="center"
                            gap="8px"
                            px="14px"
                            py="8px"
                            bg="white"
                            borderRadius="8px"
                            border="1px solid"
                            borderColor="gray.200"
                          >
                            <Text fontSize="13px" color="#5D6979">
                              {item?.campaign?.billingModel === "CPUC"
                                ? "총 클릭 수"
                                : "총 노출 수"}
                            </Text>
                            <Text fontSize="15px" fontWeight={600} color="#172940">
                              {item?.campaign?.billingModel === "CPUC"
                                ? item?.summary?.totals?.totalInteractions ?? "-"
                                : item?.summary?.totals?.totalReach ?? "-"}
                              회
                            </Text>
                          </Flex>
                          <Flex
                            align="center"
                            gap="8px"
                            px="14px"
                            py="8px"
                            bg="white"
                            borderRadius="8px"
                            border="1px solid"
                            borderColor="gray.200"
                          >
                            <Text fontSize="13px" color="#5D6979">
                              목표 달성률
                            </Text>
                            <Text fontSize="15px" fontWeight={600} color="#0054C0">
                              {(
                                (item?.summary?.totals?.goalAchievementRate ?? 0) *
                                100
                              ).toFixed(1)}
                              %
                            </Text>
                          </Flex>
                        </>
                      )}
                      {isCps ? (
                        <>
                          <Flex
                            align="center"
                            gap="8px"
                            px="14px"
                            py="8px"
                            bg="white"
                            borderRadius="8px"
                            border="1px solid"
                            borderColor="gray.200"
                          >
                            <Text fontSize={isCps ? "12px" : "13px"} color="#5D6979">클릭수</Text>
                            <Text fontSize={isCps ? "14px" : "15px"} fontWeight={600} color="#172940">
                              {Number(totalClicks ?? 0).toLocaleString()}회
                            </Text>
                          </Flex>
                          <Flex
                            align="center"
                            gap="8px"
                            px="14px"
                            py="8px"
                            bg="white"
                            borderRadius="8px"
                            border="1px solid"
                            borderColor="gray.200"
                          >
                            <Text fontSize={isCps ? "12px" : "13px"} color="#5D6979">판매수</Text>
                            <Text fontSize={isCps ? "14px" : "15px"} fontWeight={600} color="#172940">
                              {Number(item?.summary?.totals?.totalInteractions ?? 0).toLocaleString()}건
                            </Text>
                          </Flex>
                          <Flex
                            align="center"
                            gap="8px"
                            px="14px"
                            py="8px"
                            bg="white"
                            borderRadius="8px"
                            border="1px solid"
                            borderColor="gray.200"
                          >
                            <Text fontSize={isCps ? "12px" : "13px"} color="#5D6979">판매수량</Text>
                            <Text fontSize={isCps ? "14px" : "15px"} fontWeight={600} color="#172940">
                              {Number(totalQuantity ?? 0).toLocaleString()}개
                            </Text>
                          </Flex>
                          <Flex
                            align="center"
                            gap="8px"
                            px="14px"
                            py="8px"
                            bg="white"
                            borderRadius="8px"
                            border="1px solid"
                            borderColor="gray.200"
                          >
                            <Text fontSize={isCps ? "12px" : "13px"} color="#5D6979">ROAS</Text>
                            <Text fontSize={isCps ? "14px" : "15px"} fontWeight={600} color="#0054C0">
                              {Number(totalRoas ?? 0).toFixed(1)}%
                            </Text>
                          </Flex>
                          <Flex
                            align="center"
                            gap="8px"
                            px="14px"
                            py="8px"
                            bg="white"
                            borderRadius="8px"
                            border="1px solid"
                            borderColor="gray.200"
                          >
                            <Text fontSize={isCps ? "12px" : "13px"} color="#5D6979">총 원고료</Text>
                            <Text fontSize={isCps ? "14px" : "15px"} fontWeight={600} color="#172940">
                              {formatCurrency(totalManuscriptFee)}
                            </Text>
                          </Flex>
                          <Flex
                            align="center"
                            gap="8px"
                            px="14px"
                            py="8px"
                            bg="white"
                            borderRadius="8px"
                            border="1px solid"
                            borderColor="gray.200"
                          >
                            <Text fontSize={isCps ? "12px" : "13px"} color="#5D6979">커미션</Text>
                            <Text fontSize={isCps ? "14px" : "15px"} fontWeight={600} color="#172940">
                              {formatCurrency(totalExpectedCommission)}
                            </Text>
                          </Flex>
                        </>
                      ) : (
                        <Flex
                          align="center"
                          gap="8px"
                          px="14px"
                          py="8px"
                          bg="white"
                          borderRadius="8px"
                          border="1px solid"
                          borderColor="gray.200"
                        >
                          <Text fontSize="13px" color="#5D6979">차감 예정 예치금</Text>
                          <Text fontSize="15px" fontWeight={600} color="#172940">
                            {item?.summary?.totals?.expectedDeductionAmount != null
                              ? `${Number(item.summary.totals.expectedDeductionAmount).toLocaleString()}원`
                              : "-"}
                          </Text>
                        </Flex>
                      )}
                    </Flex>
                  )}
                  <AccordionIcon
                    fontSize="24px"
                    color="#0054C0"
                    flexShrink={0}
                  />
                </Flex>
              </AccordionButton>

              <AccordionPanel bg="#FAFCFF" px="18px" pt="14px" pb="18px">
                {!isCps && (
                  <SimpleGrid
                    columns={{ base: 2, md: 4 }}
                    spacing="12px"
                    w="100%"
                    mb="16px"
                  >
                  <Box
                    w="100%"
                    p="14px"
                    bg="white"
                    borderRadius="10px"
                    border="1px solid"
                    borderColor="gray.200"
                  >
                    <Text fontSize="18px" fontWeight={700}>
                      광고 진행 현황
                    </Text>
                    <Flex align="center" gap="4px">
                      <Text fontSize="24px" color="#0054C0" fontWeight={700}>
                        {progress?.totalCreators}
                      </Text>
                      <Text pt="4px" fontSize="16px" color="#0054C0">
                        /
                        {(progress?.waitingCount ?? 0) +
                          (progress?.ongoingCount ?? 0) +
                          (progress?.closingCount ?? 0)}
                      </Text>
                    </Flex>
                  </Box>

                  <Box
                    w="100%"
                    p="14px"
                    bg="white"
                    borderRadius="10px"
                    border="1px solid"
                    borderColor="gray.200"
                  >
                    <Text fontSize="18px" fontWeight={700}>
                      {isCps
                        ? "커미션율"
                        : item?.campaign?.billingModel === "CPUC"
                          ? "총 클릭 수"
                          : "총 노출 수"}
                    </Text>
                    <Flex align="center" gap="4px">
                      <Text fontSize="24px" color="#0054C0" fontWeight={700}>
                        {isCps
                          ? String(Math.round(cpsRate * 100) / 100).replace(/\.00$/, "")
                          : item?.campaign?.billingModel === "CPUC"
                            ? item?.summary?.totals?.totalInteractions
                            : item?.summary?.totals?.totalReach}
                      </Text>
                      <Text pt="4px" fontSize="16px" color="#0054C0">
                        {isCps ? "%" : "회"}
                      </Text>
                    </Flex>
                  </Box>

                  {!isCps && (
                    <Box
                      w="100%"
                      p="14px"
                      bg="white"
                      borderRadius="10px"
                      border="1px solid"
                      borderColor="gray.200"
                    >
                      <Text fontSize="18px" fontWeight={700}>
                        전체 목표 달성률
                      </Text>
                      <Flex align="center" gap="4px">
                        <Text fontSize="24px" color="#0054C0" fontWeight={700}>
                          {(
                            (item?.summary?.totals?.goalAchievementRate ?? 0) *
                            100
                          ).toFixed(2)}
                        </Text>
                        <Text pt="4px" fontSize="16px" color="#0054C0">
                          %
                        </Text>
                      </Flex>
                    </Box>
                  )}

                  {isCps ? (
                    <>
                      <Box
                        w="100%"
                        p="14px"
                        bg="white"
                        borderRadius="10px"
                        border="1px solid"
                        borderColor="gray.200"
                      >
                        <Text fontSize="18px" fontWeight={700}>총 원고료</Text>
                        <Text fontSize="24px" color="#0054C0" fontWeight={700}>
                          {formatCurrency(totalManuscriptFee)}
                        </Text>
                      </Box>
                      <Box
                        w="100%"
                        p="14px"
                        bg="white"
                        borderRadius="10px"
                        border="1px solid"
                        borderColor="gray.200"
                      >
                        <Text fontSize="18px" fontWeight={700}>총 커미션</Text>
                        <Text fontSize="24px" color="#0054C0" fontWeight={700}>
                          {formatCurrency(totalExpectedCommission)}
                        </Text>
                      </Box>
                    </>
                  ) : (
                    <Box
                      w="100%"
                      p="14px"
                      bg="white"
                      borderRadius="10px"
                      border="1px solid"
                      borderColor="gray.200"
                    >
                      <Text fontSize="18px" fontWeight={700}>차감 예정 예치금</Text>
                      <Flex align="center" gap="4px">
                        <Text fontSize="24px" color="#0054C0" fontWeight={700}>
                          {item?.summary?.totals?.expectedDeductionAmount}
                        </Text>
                        <Text pt="4px" fontSize="16px" color="#0054C0">
                          KRW
                        </Text>
                      </Flex>
                    </Box>
                  )}
                  </SimpleGrid>
                )}

                {renderChildren && (
                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing="12px">
                    {item?.creators?.map((creator) => (
                      <CreatorInfo
                        key={creator.creatorProfileId ?? creator.id}
                        data={creator}
                        campaign={{ item }}
                      />
                    ))}
                  </SimpleGrid>
                )}
              </AccordionPanel>
            </>
  );
}

export default function WaitList({ item, defaultExpanded = false }) {
  const progress = item?.summary?.progress;
  const total = progress?.totalCreators ?? 0;
  const ongoing =
    (progress?.waitingCount ?? 0) +
    (progress?.ongoingCount ?? 0) +
    (progress?.closingCount ?? 0);
  const creatorCount = item?.creators?.length ?? 0;

  return (
    <Accordion allowMultiple w="100%" defaultIndex={defaultExpanded ? [0] : []}>
      <AccordionItem
        border="1px solid"
        borderColor="rgba(0, 84, 192, 0.14)"
        bg="white"
        borderRadius="12px"
        mb="8px"
        boxShadow="0 1px 3px rgba(23, 41, 64, 0.08)"
        overflow="hidden"
        _expanded={{
          boxShadow: "0 4px 16px rgba(23, 41, 64, 0.12)",
          borderColor: "rgba(0, 84, 192, 0.2)",
        }}
      >
        {({ isExpanded }) => (
          <AccordionContent
            item={item}
            isExpanded={isExpanded}
            progress={progress}
            total={total}
            ongoing={ongoing}
            creatorCount={creatorCount}
          />
        )}
      </AccordionItem>
    </Accordion>
  );
}
